<template>
  <div class="row">
    <div class="col-md-6">
      <div class="create-user-form__section">
        <div class="create-user-form-workplaces">
          <template>
            <div class="create-user-form-workplaces__section" v-for="(place, index) in workplaces" v-bind:key="index">
              <div class="create-user-form-workplaces__title">
                {{ $t('labels.work_place') }}
              </div>
              <div class="create-user-form-workplaces__delete"
                   v-if="index > 0"
              >
                <span @click="deleteworkplaces(index)">{{ $t('labels.delete_work_place') }}</span>
              </div>
              <div class="create-user-form-workplaces__tree el-input el-input--prefix"
                   v-bind:class="{ showLabel: workplaces[index].org_id }">
                <tree-select @checked="orgChecked"
                             :placeholder="$t('labels.organization_structure')"
                             :data="depTree"
                             :index="index"
                             nodeKey="id"
                             ref="workplaceTree">
                </tree-select>
                <span class="el-input__prefix">
                    <label v-if="!workplaces[index].org_id"
                           class="label-error">
                         {{ error.org.message }}
                    </label>
                    <label v-else>{{ $t('labels.organization_structure') }}</label>
                  </span>
              </div>
              <el-input
                        v-bind:class="{ showLabel: workplaces[index].note }"
                        v-model="workplaces[index].note"
                        type="text"
                        :placeholder="$t('labels.position')">
                    <label slot="prefix">{{ $t('labels.position') }}</label>
                </el-input>
            </div>
          </template>
          <div class="create-user-form-workplaces__add" @click="addworkplaces()">
            {{ $t('labels.add_work_place') }}
          </div>
        </div>
      </div>
      <div class="create-user-form__section">
        <div class="create-user-form-roles">
          <div class="create-user-form__section-title">
            {{ $t('labels.permitted_actions') }} <span class="required-icon">*</span>
            <div v-if="error.roles.invalid" class="create-user-form__section-error">
              {{ error.roles.message }}
            </div>
          </div>
          <roles-switcher v-model="userData.roles"></roles-switcher>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  // import getDepartmentList from '@/services/departmentList'
  import TreeSelect from 'src/components/TreeSelect/TreeSelect.vue'
  import _ from 'lodash'
  import rolesSwitcher from 'src/components/Users/RolesSwitcher.vue'

  export default {
    components: {
      TreeSelect,
      rolesSwitcher
    },
    data () {
      return {
        workplaces: [{
          org_id: '',
          note: ''
        }],
        userData: {
          roles: []
        },
        depList: [],
        servicesTree: [],
        depTree: [],
        queryPosts: [],
        specialtyList: [],
        specialtyAddVisibility: false,
        checkedOrgs: [],
        checkedSpecialties: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        postsList: [],
        error: {
          org: {
            invalid: false,
            message: ''
          },
          roles: {
            invalid: false,
            message: ''
          }
        }
      }
    },
    methods: {
      addworkplaces () {
        this.workplaces.push({org_id: '', note: ''})
      },
      deleteworkplaces (index) {
        // this.undisableOrg(this.workplaces[index].id)
        this.workplaces.splice(index, 1);
        this.checkedOrgs.splice(index, 1);
      },
      async getDepTree () {
        try {
          let list = await this.$store.dispatch('orgs/loadRawOrgList')
          let tree = this.$store.getters['orgs/getRawTree'](list)
          this.depTree = tree;
        } catch (error) {
          console.error('LOG: getDepList -> error', error)
        }
      },
      remotePosts (value) {
        if (value !== '') {
          this.queryPosts = this.postsList.filter(item => {
            return item.key.toLowerCase()
              .indexOf(value.toLowerCase()) > -1;
          });
        } else {
          this.queryPosts = []
        }
      },
      orgChecked (data, checked, index) {
        let self = this;
        if (!this.isAlredyChecked(data.id)) {
          this.workplaces[index].org_id = data.id
          this.checkedOrgs.push(data.id)
        } else {
          // @ts-ignore
          this.$message({
            // @ts-ignore
            message: this.$t('labels.organization_added_above'),
            type: 'warning'
          });
          setTimeout(() => {
            self.$refs.workplaceTree[index].reset()
          }, 3000)
        }
      },
      isAlredyChecked (orgId) {
        if (this.checkedOrgs.indexOf(orgId) >= 0) {
          return true;
        }
      },
      formReset () {
        this.workplaces = [{
          org_id: '',
          note: ''
        }]

        this.checkedOrgs = []
        this.$refs.workplaceTree[0].reset()
      },
      setError (key, message) {
        this.error[key].invalid = true;
        this.error[key].message = message;
      },
      validate () {
        if(!this.userData.roles.length) {
          this.setError('roles', this.$t('labels.enter_min_one_action'))
        }
      },
      resetError () {
        let error = this.error;

        for (let item in error) {
          this.error[item].invalid = false;
          this.error[item].mesage = '';
        }
      },
      isStepValid () {
        this.validate();
        let error = this.error;
        let isValid = true;
        for (let item in error) {
          if (this.error[item].invalid === true) {
            isValid = false;
          }
        }
        return isValid;
      },
      getData () {
        let orgs = this.workplaces.filter(function(org) {
          return org.org_id;
        });
        let roles = _.cloneDeep(this.userData.roles)
        return {orgs, roles}
      }
    },
    computed: {
    },
    async mounted () {
      await this.getDepTree()
    },
    watch: {
      userData: {
        handler: function (val, oldVal) {
          this.resetError();
        },
        deep: true
      },
      workplaces: {
        handler: function (val, oldVal) {
          this.resetError();
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss">
  .create-user-form-workplaces {
    .tree-select {
      margin-bottom: 0;
    }
    &__services {
      margin-bottom: 30px;
      .tree-select {
        margin-bottom: 15px;
      }
    }
  }
  .create-user-form-roles {

    &__select-container {
      margin-bottom: 20px;
    }

    .el-input {
      margin-bottom: 0 !important;
    }

    &__add {
      padding-top: 8px;
      border-top: 1px solid #dcdfe6;
      color: #2196F3;
      cursor: pointer;

      &:hover {
        color: lighten(#2196F3, 15%);
      }
    }


    &__delete {
      span {
        font-size: 12px;
        color: #2196F3;
        cursor: pointer;

        &:hover {
          color: lighten(#2196F3, 15%);
        }
      }
    }
  }

  .create-user-specialty-add {
    padding: 30px 0;
    border-bottom: 1px solid #dcdfe6;
    border-top: 1px solid #dcdfe6;
    margin-bottom: 30px;

    &__title {
      font-size: 28px;
      margin-bottom: 20px;
      font-weight: 600;
    }
  }
</style>
